import { HistoryOutlined } from '@ant-design/icons';

import { useState } from 'react';

import { Space, Typography, Tag, message } from 'antd';
import moment from 'moment';

import HistoryModal from './HistoryModal';
import { getColor, getError, getLabel } from '../../clientUtils';
import * as Constants from '../../constants';

const { Title, Text } = Typography;

const CustomHeader = ({
  title,
  tag,
  info,
  kebabMenu,
  history,
  historyFetchFn,
  attachmentHistoryFetchFn,
  extraTags = []
}) => {
  const { updatedBy, updatedOn } = info || {};
  const [openHistory, setOpenHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [attachmentHistoryData, setAttachmentHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleModalClose = () => {
    setOpenHistory(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = historyFetchFn && (await historyFetchFn());
      setHistoryData(data);
    } catch (error) {
      message.error(getError(error));
    } finally {
      setLoading(false);
    }
  };

  const fetchAttachmentData = async () => {
    setLoading(true);
    try {
      const data = attachmentHistoryFetchFn && (await attachmentHistoryFetchFn());
      setAttachmentHistoryData(data);
    } catch (error) {
      message.error(getError(error));
    } finally {
      setLoading(false);
    }
  };

  const handleModalOpen = () => {
    fetchData();
    fetchAttachmentData();
    setOpenHistory(true);
  };

  return (
    <Space className="w-100 jc-space-between">
      <HistoryModal
        attachmentHistoryData={attachmentHistoryData}
        comments={history}
        history={historyData}
        isOpen={openHistory}
        loading={loading}
        onCancel={handleModalClose}
        title={title}
      />
      <Space align="center" size="middle">
        <Title>{title}</Title>
        {!!tag && (
          <Tag bordered={false} className="br-20 capitalize" color={getColor(tag)}>
            {getLabel(tag)}
          </Tag>
        )}
        {extraTags?.map((extraTag) => (
          <span key={`custom-header-extra-tag-${extraTag?.key || extraTag?.props?.children || 'tag'}`}>{extraTag}</span>
        ))}
      </Space>
      <Space size="middle">
        {!!info && (
          <Space>
            <Text type="secondary">Last edited by</Text>
            <Text>
              {updatedBy} on {moment(updatedOn)?.format(Constants.DATE_FORMAT)}
            </Text>
          </Space>
        )}
        {!!history && <HistoryOutlined onClick={handleModalOpen} style={{ color: '#2cb695', fontSize: '17px' }} />}
        {kebabMenu || null}
      </Space>
    </Space>
  );
};
export default CustomHeader;
